<template>
  <div id="FinanciamentoCheckout">
    <Financiamento/>
  </div>
</template>

<script>
import Financiamento from "@/components/checkout/financiamento/Financiamento";


export default {
  components: {
    Financiamento
  },
};
</script>